export const input = (value?: string, regex?: RegExp) => ({
  showPassword: false,
  disabled: false,
  value: value || '',
  label: '',
  required: false,
  error: false,
  type: undefined,
  errors: {
    required: false,
    invalidChars: false,
    email: false,
  },
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.$refs.input.type = this.showPassword ? 'text' : 'password';
    this.$refs.input.focus();
  },
  validate() {
    this.resetErrors(); // Reset errors at the beginning to ensure a clean start

    if (regex) {
      if (this.required && !this.value.trim().length) {
        this.$refs.input.setCustomValidity(`${this.label} ist erforderlich.`);
        this.error = true;
        this.errors.required = true;
      } else {
        const valid = regex.test(this.value);
        this.error = !valid;

        if (!valid) {
          this.$refs.input.setCustomValidity(
            `${this.label} enthält ungültige Zeichen.`
          );
          this.errors.invalidChars = true;
        } else {
          this.$refs.input.setCustomValidity('');
        }
      }
    } else {
      if (this.type === 'email') {
        if (this.required && !this.value.trim().length) {
          this.error = true;
          this.errors.required = true;
          this.$refs.input.setCustomValidity(`${this.label} ist erforderlich.`);
        } else {
          const valid = /^[\w-.+]+@([\w-]+\.)+[\w-]+$/.test(this.value);
          this.error = !valid;
          this.errors.email = !valid;
          if (!valid) {
            this.$refs.input.setCustomValidity(
              `${this.label} enthält ungültige Zeichen.`
            );
          } else {
            this.$refs.input.setCustomValidity('');
            this.errors.required = false;
          }
        }
      } else {
        if (this.required && !this.value.trim().length) {
          this.error = true;
          this.errors.required = true;
          this.$refs.input.setCustomValidity(`${this.label} ist erforderlich.`);
        } else {
          this.error = false;
          this.$refs.input.setCustomValidity('');
        }
      }
    }
  },
  resetErrors() {
    this.errors.required = false;
    this.errors.invalidChars = false;
    this.errors.email = false;
  },
  init() {
    this.label = this.$refs.label.innerText;
    this.required = this.$refs.input.required;
    this.type = this.$refs.input.type || 'text';
  },
});
